/**
 * The value to seed the in-memory "last analysed text" snapshot with when a draft loads.
 *
 * TRIL-605. This used to be `extractTextFromBlocks(draft.textBlocks)` inline in
 * PostDraft.component.tsx — seeding the snapshot from the draft's CURRENT text. The draft
 * slice is not persisted, so every reload ran that branch, and whatever the draft said at
 * that moment became "the text that was analysed". Any edit made since the analysis was
 * absorbed, so analyze -> edit -> save -> reload read as fresh and left Publish unlocked
 * with an analysis that no longer described the text.
 *
 * TRIL-604 persists the real value server-side; this reads it.
 *
 * Returning null when it is absent is the load-bearing half. Null propagates to
 * `shouldReanalyzeOnEdit`, which fails safe and re-analyses. Falling back to the current
 * text instead would assert "unchanged" on evidence we do not have — which is the bug,
 * not a milder version of it. Analyses written before TRIL-604 carry no value and take
 * the safe branch by construction.
 */
export function seedAnalyzedSnapshot(
  // Deliberately NOT PostDraftInterface. This takes the getDraftById RESULT, which is the
  // only shape that carries the field — the Redux draft comes from the LIST query and never
  // does. Typing it as the draft is what made the wrong source look correct at the call site.
  draftDetail: { lastAnalyzedText?: string | null } | null | undefined,
): string | null {
  return draftDetail?.lastAnalyzedText ?? null;
}
